module.exports = __webpack_public_path__ + "static/media/dashboard.95c8407d.svg";